import {combineReducers} from 'redux';
import activate from './activate.reducer';

const activationReducer = combineReducers({
	activate,
});

export default activationReducer;